<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card :title="title" :color="$vuetify.theme.themes.light.primary" icon="add" v-if="item">
        <v-card-text v-if="plans">
          <v-form v-model="valid" v-if="model">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{ $t("components.claims_settings.explanation") }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <v-autocomplete
                        :label="$t('globals.plan')"
                        v-model="item.Plan"
                        :items="plans"
                        item-text="Number"
                        item-value="PlanId"
                        hide-details
                        clearable
                        return-object
                        :rules="[$rules.required]"
                        class="required"
                        :loading="loading"
                        v-if="item.PlanId === null || item.PlanId === undefined"
                      ></v-autocomplete>
                      <span v-else>
                        {{ item.Plan.Number }}
                      </span>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="$t('globals.plan_name')"
                        v-model="item.EOBPlanName"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        v-model="item.EOBPlanPhone"
                        :label="$t('headers.locals.phone_number')"
                        :rules="[rules.phone]"
                        v-mask="telephoneMask"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        v-model="item.EOBPlanEmail"
                        :label="$t('components.claim_settings.contact_email')"
                        :rules="[$rules.email]"
                      ></no-autocomplete-textfield>
                    </div>
                  </v-row>
                  <v-row justify-center>
                    <div class="col-12 col-xs-12">
                      <span class="text-h6 ml-1 required-label">
                        {{ $t("globals.address") }}
                      </span>
                      <canada-post-address
                        :stringAddress="item.EOBPlanAddress"
                        @update-string="updateAddress"
                        @valid="validAddress = $event"
                        :isRequired="true"
                      />
                    </div>
                  </v-row>
                  <v-row justify-center>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <trans-select2
                        v-model="item"
                        propertyName="ClaimAdmin"
                        :items="claimAdmins"
                        :label="$t('components.claims_settings.claim_admin')"
                        field="Name"
                        itemValue="Id"
                      ></trans-select2>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <trans-select2
                        v-model="item"
                        propertyName="Underwriter"
                        :items="underwriters"
                        :label="$t('components.claims_settings.underwriter')"
                        field="Name"
                        itemValue="Id"
                      ></trans-select2>
                    </div>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{ $t("components.claims_settings.claim_auditing") }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="$t('headers.claims_settings.audit_percentage')"
                        :value.sync="item.AuditPercentage"
                        :rules="[
                          $rules.integer,
                          $rules.dynamic.minValue(0),
                          $rules.dynamic.maxValue(100),
                        ]"
                        prefix="%"
                        clearable
                      ></no-autocomplete-textfield>
                    </div>
                    <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <currency-textfield
                        v-model="item.DispensingFeeCap"
                        :label="
                          $t('headers.claims_settings.dispensing_fee_cap')
                        "
                        :rules="[$rules.decimal]"
                        clearable
                      />
                    </div> -->
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{ $t("components.claims_settings.payments_settings") }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <v-select
                        :label="$t('headers.claims_settings.bank')"
                        v-model="item.BankShortName"
                        :items="options.Enums.BankShortName"
                        :rules="[$rules.required]"
                        class="required"
                      ></v-select>
                    </div>
                  </v-row>
                  <v-row justify-center v-if="item.BankShortName">
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="$t('headers.claims_settings.client_id')"
                        v-model="item.ClientID"
                        :rules="[$rules.required, $rules.dynamic.length(10)]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                      v-if="item.BankShortName === 'RBC'"
                    >
                      <no-autocomplete-textfield
                        :label="
                          $t('headers.claims_settings.payee_match_number')
                        "
                        v-model="item.PayeeMatchNumber"
                        :rules="[$rules.required, $rules.dynamic.length(9)]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="
                          $t('headers.members_management.Institution Number')
                        "
                        :value.sync="item.InstitutionNumber"
                        :rules="
                          isBankAccountRequired()
                            ? [
                                $rules.required,
                                $rules.canadianBankInstitutionNumber,
                              ]
                            : []
                        "
                        :class="bankAccountClass()"
                        clearable
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Transit Number')"
                        :value.sync="item.TransitNumber"
                        :rules="
                          isBankAccountRequired()
                            ? [
                                $rules.required,
                                $rules.canadianBankTransitNumber,
                              ]
                            : []
                        "
                        :class="bankAccountClass()"
                        clearable
                      ></no-autocomplete-textfield>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                      <no-autocomplete-textfield
                        :label="$t('headers.members_management.Account Number')"
                        :value.sync="item.AccountNumber"
                        :rules="
                          isBankAccountRequired()
                            ? [
                                $rules.required,
                                $rules.canadianBankAccountNumber,
                              ]
                            : []
                        "
                        :class="bankAccountClass()"
                        clearable
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                      v-if="item.BankShortName === 'RBC'"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.claims_settings.srf_number')"
                        v-model="item.SrfNumber"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                      v-if="item.BankShortName === 'HSBC'"
                    >
                      <no-autocomplete-textfield
                        :label="$t('headers.claims_settings.company_long_name')"
                        v-model="item.CompanyLongName"
                        :rules="[
                          $rules.required,
                          $rules.dynamic.upToLength(30),
                        ]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </div>
                    <div
                      class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                      v-if="item.BankShortName === 'HSBC'"
                    >
                      <no-autocomplete-textfield
                        :label="
                          $t('headers.claims_settings.company_short_name')
                        "
                        v-model="item.CompanyShortName"
                        :rules="[
                          $rules.required,
                          $rules.dynamic.upToLength(15),
                        ]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </div>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-container></v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="saving">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="validateDirectDeposit"
            :disabled="!valid || !validAddress"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <!-- <v-dialog scrollable v-model="loading" persistent max-width="200">
        <v-card>
          <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row justify-center>
                <v-flex xs12 sm6 md4 lg3>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog> -->
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.warning"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="confirmBankAccountDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              save();
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";
import TransSelect2 from "../TransSelect2.vue";

export default {
  props: ["model", "item", "brokerId", "planName"],
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    CanadaPostAddress,
    TransSelect2,
  },
  directives: { mask },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      plans: [],
      rules: {
        bankAccount: (v) => {
          if (this.isBankAccountRequired()) {
            return this.$rules.required(v);
          }
          return true;
        },
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      telephoneMask: "(###) ### - ####",
      loading: false,
      confirmBankAccountDialog: false,
      validAddress: false,
      claimAdmins: [],
      underwriters: []
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    title() {
      if (this.item && this.item.PlanId) {
        return this.$t("globals.edit");
      }
      return this.$t("globals.add");
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadPlans();
          console.log(this.item);
          if (this.item && this.item.PlanId) {
            if (
              this.item.EOBPlanName === null ||
              this.item.EOBPlanName === undefined
            ) {
              this.item.EOBPlanName = this.planName;
            }
            if (
              this.item.EOBPlanPhone === null ||
              this.item.EOBPlanPhone === undefined
            ) {
              this.item.EOBPlanPhone = this.unmask(
                this.item.EOBPlanPhone,
                this.telephoneMask
              );
            }
            if (
              this.item.EOBPlanAddress !== null &&
              this.item.EOBPlanAddress !== undefined
            ) {
              this.validAddress = true;
            }
          }
          console.log(this.valid, this.validAddress)
        }
      },
    },
    "item.BankShortName": {
      handler(v) {
        if (v === "RBC") {
          delete this.item.CompanyLongName;
          delete this.item.CompanyShortName;
        } else if (v === "HSBC") {
          delete this.item.SrfNumber;
          delete this.item.PayeeMatchNumber;
        }
      },
    },
    "item.BankShortName": {
      handler(v) {
        if (v === "RBC") {
          delete this.item.CompanyLongName;
          delete this.item.CompanyShortName;
        } else if (v === "HSBC") {
          delete this.item.SrfNumber;
          delete this.item.PayeeMatchNumber;
        }
      },
    },
  },
  mounted() {
    this.loadPlans();
  },
  methods: {
    ...mapActions("claims", [
      "getPlansWithoutClaimSettings",
      "addClaimSettings",
      "updateClaimSettings",
      "getClaimAdmins",
      "getUnderwriters"
    ]),
    ...mapActions("plansMembers", ["validateBankAccount", "getPlan"]),
    updateAddress(address) {
      console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", address);
      this.item.EOBPlanAddress = address;
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async loadPlans() {
      this.loading = true;
      try {
        this.plans = (
          await this.getPlansWithoutClaimSettings({
            brokerId: this.brokerId,
          })
        ).data;
        this.claimAdmins = (await this.getClaimAdmins()).data.value;
        this.underwriters = (await this.getUnderwriters()).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      if (item.ClaimAdmin) {
        item.ClaimAdminId = item.ClaimAdmin.Id;
        delete item.ClaimAdmin;
      }
      if (item.Underwriter) {
        item.UnderwriterId = item.Underwriter.Id;
        delete item.Underwriter;
      }
      if (item.PlanId) {
        item.PlanId = item.Plan.PlanId;
        delete item.Plan;
        return this.update(item);
      }
      item.PlanId = item.Plan.PlanId;
      delete item.Plan;
      return this.add(item);
    },
    async add(item) {
      try {
        this.saving = true;
        await this.addClaimSettings({
          payload: item,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.$emit("saved");
      }
    },
    async update(item) {
      try {
        this.saving = true;
        await this.updateClaimSettings({
          id: item.PlanId,
          payload: item,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.$emit("saved");
      }
    },
    isBankAccountRequired() {
      let req =
        (this.item.InstitutionNumber !== null &&
          this.item.InstitutionNumber !== undefined &&
          this.item.InstitutionNumber !== "") ||
        (this.item.AccountNumber !== null &&
          this.item.AccountNumber !== undefined &&
          this.item.AccountNumber !== "") ||
        (this.item.TransitNumber !== null &&
          this.item.TransitNumber !== undefined &&
          this.item.TransitNumber !== "");
      console.log("bank account required: ", req, this.item);
      return req;
    },
    bankAccountClass() {
      if (this.isBankAccountRequired()) {
        return "required";
      }
      return "";
    },
    async validateDirectDeposit() {
      if (this.isBankAccountRequired()) {
        this.saving = true;
        try {
          const valid = (
            await this.validateBankAccount({
              payload: {
                InstitutionNumber: this.item.InstitutionNumber,
                TransitNumber: this.item.TransitNumber,
              },
            })
          ).data;

          if (!valid) {
            this.confirmBankAccountDialog = true;
          } else {
            this.save();
          }
        } catch (error) {
          this.error = error;
        } finally {
          this.saving = false;
        }
      } else {
        this.save();
      }
    },
  },
};
</script>

<style scoped></style>
